import React from "react"
import Link, { LinkProps } from "next/link"
import { generateClassName } from "@smoothincorg/smooth-ui"

type AnchorProps = LinkProps & Omit<JSX.IntrinsicElements["a"], keyof LinkProps>

const { getRootClassName } = generateClassName("A")

// eslint-disable-next-line react/display-name
export const A = React.forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <Link {...props} className={getRootClassName({ className })} ref={ref}>
        {children}
      </Link>
    )
  }
)
